import $ from 'jquery'
import {Core} from "../../../assets/src/scripts/core.js";

export class TableOffer {

  constructor($container) {
    if (Core.isAdmin()) return

    this.$window = $(window)
    this.$document = $(document)
    this.$container = $container

    this.classes = {
      'hover': 'cell-hover',
      'click': 'cell-clicked'
    }
    this.$menu = this.$container.find('.table-offer-menu')
    this.$content = this.$container.find('.table-offer-content')
    this.$header = this.$container.find('.table-offer-header')
    this.$body = this.$container.find('.table-offer-body')
    this.$footer = this.$container.find('.table-offer-footer')
    this.$dots = this.$container.find('.table-offer-dots')
    this.$cells = this.$container.find('.cell')

    this.indexSlideActive = 0

    this.handleHoverCell()

    this.$document.ready(this.handleReady.bind(this))
    this.$window.on('resize', this.refresh.bind(this))
    this.$cells.on('click', this.handleClickCell.bind(this))
    this.$menu.find('> div').on('click', this.handleClickMenu.bind(this))
    this.$dots.find('> div').on('click', this.handleClickDots.bind(this))
  }

  refresh() {
    this.$content.find('[style]').removeAttr('style')
    this.fixCellHeight()

    if (Core.isBpGreaterThan('xl')) return

    this.slideToCol(this.indexSlideActive)
  }

  handleReady(e) {
    setTimeout(this.fixCellHeight.bind(this), 500)
  }

  handleClickMenu(e) {
    e.preventDefault()
    this.slideToCol($(e.currentTarget).index())
  }

  handleClickDots(e) {
    e.preventDefault()
    this.slideToCol($(e.currentTarget).index())
  }

  handleClickCell(e) {
    let $elt = $(e.target)

    if ($elt.prop('tagName') === 'A') return
    if (!Core.isBpGreaterThan('xl')) return

    e.preventDefault()
    let $cell = $(e.currentTarget)

    if ($cell.hasClass(this.classes.click)) {
      this.removeClassToAllCellsInCol(-1, this.classes.click)
    } else {
      this.removeClassToAllCellsInCol(-1, this.classes.click)
      let indexCol = this.getIndexColBy($cell)

      if (indexCol === 0) return
      this.addClassToAllCellsInCol(indexCol, this.classes.click)
    }
  }

  handleHoverCell() {
    let self = this
    let saveIndexCol = 0
    let saveCounterMouseEnter = 0

    this.$cells.on('mouseenter', (e) => {
      if (!Core.isBpGreaterThan('xl')) return

      let $cell = $(e.currentTarget)
      let indexCol

      // Get index of cell
      indexCol = self.getIndexColBy($cell)
      saveIndexCol = indexCol
      saveCounterMouseEnter += 1

      if (indexCol !== 0) {
        self.addClassToAllCellsInCol(indexCol, self.classes.hover)
      }
    })

    this.$cells.on('mouseleave', () => {
      let counterMouseEnter = saveCounterMouseEnter
      let indexCol = saveIndexCol

      setTimeout(() => {
        if ((indexCol !== saveIndexCol) || (counterMouseEnter === saveCounterMouseEnter && indexCol === saveIndexCol)) {
          self.removeClassToAllCellsInCol(indexCol, self.classes.hover)
        }
      }, 50)
    })
  }

  /**
   * Renvoie l'index de la colonne de la cellule
   */
  getIndexColBy($cell) {
    if ($cell.closest('.table-offer-body').length) {
      return $cell.parent().index()
    } else {
      return $cell.index()
    }
  }

  /**
   * Ajoute une classe à toutes les cellules de la colonne
   *
   * @param indexCol
   * @param classCell
   */
  addClassToAllCellsInCol(indexCol, classCell) {
    let cellHeaderHover = this.$header.find('.cell').eq(indexCol)

    cellHeaderHover.addClass(classCell)
    this.$body.find('.col').eq(indexCol).find('.cell').addClass(classCell)
    this.$footer.find('.cell').eq(indexCol).addClass(classCell)

    cellHeaderHover.find('.cell-content').css('--before-height', `${this.$content.height()}px`)
  }

  /**
   * Supprime la classe à toutes les cellules de la colonne
   *
   * @param indexCol
   * @param classCell
   */
  removeClassToAllCellsInCol(indexCol, classCell) {
    if (indexCol === -1) {
      this.$container.find(`.${classCell}`).removeClass(classCell)
    }

    let cellHeaderHover = this.$header.find('.cell').eq(indexCol)

    cellHeaderHover.removeClass(classCell)
    this.$body.find('.col').eq(indexCol).find('.cell').removeClass(classCell)
    this.$footer.find('.cell').eq(indexCol).removeClass(classCell)
  }

  /**
   * Permet d'obtenir la même hauteur pour toutes les cellules d'une même ligne
   */
  fixCellHeight() {
    let $header = this.$container.find('.table-offer-header > div')
    let heightCell = 32
    $header.each((colIndex, cell) => {
      let heightCurrentCell = $(cell).innerHeight()

      if (colIndex === 0) {
        heightCell = 0
      } else if (heightCell < heightCurrentCell) {
        heightCell = heightCurrentCell
      }
    })
    $header.each((cellIndex, cell) => {
      $(cell).css('height', heightCell + "px");
    })
    this.$container.find('.cell-image img').css({
      height: '100%'
    })

    let $bodyCol = this.$container.find('.table-offer-body > div')
    let heightCells = []
    $bodyCol.each((colIndex, col) => {
      $(col).find('.cell').each((cellIndex, cell) => {
        let heightCell = $(cell).innerHeight()

        if (colIndex === 0 || parseInt(heightCells[cellIndex]) < heightCell) {
          heightCells[cellIndex] = heightCell
        }
      })
    })
    $bodyCol.each((colIndex, col) => {
      $(col).find('.cell').each((cellIndex, cell) => {
        $(cell).css('height', heightCells[cellIndex] + "px");
      })
    })

    let $footer = this.$footer.find('.table-offer-footer > div')
    $footer.each((colIndex, cell) => {
      let heightCurrentCell = $(cell).innerHeight()

      if (colIndex === 0) {
        heightCell = 0
      } else if (heightCell < heightCurrentCell) {
        heightCell = heightCurrentCell
      }
    })
    $footer.each((cellIndex, cell) => {
      $(cell).css('height', heightCell + "px");
    })
  }

  slideToCol(indexCol) {
    this.indexSlideActive = indexCol
    let leftPositionMenu = this.$content.offset().left

    // Menu
    let $itemActive = this.$menu.find('> div').eq(indexCol)
    this.$menu.find('.active').removeClass('active')
    $itemActive.addClass('active')
    this.$menu.animate({
      scrollLeft: `+=${$itemActive.offset().left - leftPositionMenu}px`
    }, 150);

    // Dots
    $itemActive = this.$dots.find('> div').eq(indexCol)
    this.$dots.find('.active').removeClass('active')
    $itemActive.addClass('active')

    // Body
    let leftPositionCol = 0
    for (let i = 1; i <= indexCol; i++) {
      leftPositionCol += this.$body.find('> div').eq(i).outerWidth(true)
    }
    if (indexCol > 0) leftPositionCol += 16
    this.$content.find('> div').css('transform', `translateX(-${leftPositionCol}px)`)
  }
}
